<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Imprimir control de reparto</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">
          <FloatLabel label="Repartidor" clase=" col-md-6 col-12">
            <select
              id="repartidor"
              class="form-control"
              :class="(enviado && !$v.repartidor.required) ? 'is-invalid' : ''"
              v-model="repartidor"
            >
              <option value="null">Repartidor</option>
              <option value="TT">TT</option>
              <option value="TM">TM</option>
              <option value="D">D</option>
              <option value="J">J</option>
              <option value="N">N</option>
              <option value="F">F</option>
              <option value="C">C</option>
            </select>
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.repartidor.required"
              >Debe seleccionar repartidor</div>
            </template>
          </FloatLabel>
          <float-label label="Comision:" clase="col-md-6 col-12" append="%">
              <input
                v-model="comision"
                id="importe"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.comision.required || !$v.comision.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.comision.required"
                >Debe ingresar el porcentaje</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.comision.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
          <float-label label="Desde:" clase="col-md-6 col-12">
            <input
              v-model="desde"
              id="desde"
              type="date"
              class="form-control"
              :class="(enviado && !$v.desde.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.desde.required"
              >Debe seleccionar la fecha</div>
            </template>
          </float-label>
          <float-label label="Hasta:" clase="col-md-6 col-12">
            <input
              v-model="hasta"
              id="hasta"
              type="date"
              class="form-control"
              :class="(enviado && !$v.hasta.required) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.hasta.required"
              >Debe seleccionar la fecha</div>
            </template>
          </float-label>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
          <div class="col-md-4 offset-md-4">
            <button class="btn btn-info btn-block mb-2" @click="mostrarPDF">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required, decimal } from "vuelidate/lib/validators";
import axios from "axios";
import moment from 'moment';
export default {
  name: "modalCuentasClientes",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      desde: null,
      hasta: null,
      repartidor: null,
      comision: null,
      vendedores: [],
      enviado: false
    };
  },
  validations: {
    repartidor: { required },
    comision: { required, decimal },
    desde: { required },
    hasta: { required }
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  mounted() {
    this.hasta = moment().format('Y-MM-DD');
    this.desde = moment().subtract(1, 'days').format('Y-MM-DD');
  },
  methods: {
    mostrarPDF() {
      this.$v.$touch();
      this.enviado = true;
      if (this.$v.$invalid) {
        return false;
      }
      let url =
        axios.defaults.baseURL +
        '/imprimir/control-reparto?repartidor='+this.repartidor+'&desde='+this.desde+'&hasta='+this.hasta+'&comision='+this.comision;
      window.open(url);
    //   this.cerrarModal();
    },
    cerrarModal() {
      this.$emit("cerrarControlReparto");
    }
  }
};
</script>
